export const MAIL_SEND_START = 'MAIL_SEND_START';
export const MAIL_SEND_SUCCESS = 'MAIL_SEND_SUCCESS';
export const MAIL_SEND_FAIL = 'MAIL_SEND_FAIL';

export const SET_DURATION_AND_DISTANCE = 'SET_DURATION_AND_DISTANCE';
export const GET_FARE_START = 'GET_FARE_START';
export const GET_FARE_SUCCESS = 'GET_FARE_SUCCESS';
export const GET_FARE_FAIL = 'GET_FARE_FAIL';

export const BOOK_START = 'BOOK_START';
export const BOOK_SUCCESS = 'BOOK_SUCCESS';
export const BOOK_FAIL = 'BOOK_FAIL';

/* export const SET_PICKUP_LOCATION = 'SET_PICKUP_LOCATION';
export const SET_DROPOFF_LOCATION = 'SET_DROPOFF_LOCATION'; */
